import React, { useCallback, useEffect, useState } from "react";
import styles from "./TrailPeriodAlert.module.css";
import { themeColors } from "../theme";
import { connect, useDispatch } from "react-redux";
import { subscriptionDetailsData } from "../mockData";
import useRazorpay from "react-razorpay";
import axios from "axios";
import { useHistory } from "react-router";

const TrailPreriodAlert = ({ expirationDate, role, organizationData }: any) => {
  const history = useHistory();


  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: "10px" }}>
      <div className="d-flex flex-column align-items-center m-auto p-2 alert alert-danger" style={{ zIndex: 1000, width: "40%", height: "30px", position: 'absolute', display: 'flex', alignItems: "center", justifyContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center' }}>
          {`Trial allows ${organizationData?.org_trial_period_users_licenses} users, ends in 7 days. Pay to avoid deactivation.`}
          {role === "Admin" &&
            <div>
              <button
                onClick={() => {
                  history.push("/paymentDetails");
                }}
                className={styles.button}
                style={{ fontSize: "12px", fontWeight: "400", padding: 0, height: "20px", marginLeft: "5px" }}
              >
                Renew Now
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    expirationDate: state.organization.expirationDate,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(TrailPreriodAlert);
